export const products = [
  {
    id: 1,
    name: "Plain Makhana",
    cat: "foxnuts",
    catLabel: "Foxnuts",
    image: "/plain-makhana.png",
    bgColor: "#E8F5E9",
    moq: "500kg",
    grade: "Premium Grade",
    desc: "Premium quality handpicked plain foxnuts directly sourced from Bihar and UP farms.",
    longDesc: "Our Plain Makhana is carefully processed to ensure high nutritional value, uniform size, and optimum crunch. Naturally low in sodium and rich in antioxidants.",
    pkg: ["METPET Pouch", "Bulk PP Bag"]
  },
  {
    id: 2,
    name: "Flavored Makhana",
    cat: "foxnuts",
    catLabel: "Foxnuts",
    image: "/flavored-makhana.png",
    bgColor: "#FFF3E0",
    moq: "500kg",
    grade: "Export Grade",
    desc: "Roasted and seasoned makhana available in multiple international flavors.",
    longDesc: "Perfectly roasted foxnuts seasoned with premium organic spices. Custom flavor profiles available according to target market requirements.",
    pkg: ["Matte Zipper Pouch", "Retail Boxes"]
  },
  {
    id: 3,
    name: "Frozen Green Peas",
    cat: "frozen",
    catLabel: "Frozen Foods",
    image: "/frozen-green-peas.png",
    bgColor: "#E8F5E9",
    moq: "500kg",
    grade: "A-Grade IQF",
    desc: "Individually Quick Frozen (IQF) fresh sweet green peas, sweet and nutritious.",
    longDesc: "Processed at peak freshness through advanced IQF technology to retain natural color, taste, and sweetness without any added preservatives.",
    pkg: ["Vacuum Packed Bags", "LDPE Premium Bags"]
  },
  {
    id: 4,
    name: "Frozen Sweet Corn",
    cat: "frozen",
    catLabel: "Frozen Foods",
    image: "/frozen-sweet-corn.png",
    bgColor: "#FFFDE7",
    moq: "500kg",
    grade: "Premium Sweet IQF",
    desc: "Crisp and juicy sweet corn kernels, frozen quickly to preserve quality.",
    longDesc: "Golden yellow sweet corn kernels sourced from selected sweet corn varieties. Perfectly cleaned, blanched, and quick-frozen.",
    pkg: ["Vacuum Packed Bags", "Bulk Catering Packs"]
  },
  {
    id: 5,
    name: "Mix Veg 4-Way",
    cat: "frozen",
    catLabel: "Frozen Foods",
    image: "/mix-veg-4-way.png",
    bgColor: "#E8F5E9",
    moq: "500kg",
    grade: "Export Standard",
    desc: "Perfect blend of diced carrots, green peas, sweet corn, and French beans.",
    longDesc: "Individually Quick Frozen (IQF) 4-way mix vegetable blend. Diced and proportioned meticulously to cater to international hospitality, catering, and retail needs.",
    pkg: ["Vacuum Bags", "BOPP Export Packing"]
  },
  {
    id: 11,
    name: "Mix Veg 5-Way",
    cat: "frozen",
    catLabel: "Frozen Foods",
    image: "/mix-veg-5-way.png",
    bgColor: "#E8F5E9",
    moq: "500kg",
    grade: "Export Standard",
    desc: "Premium mix of carrots, green peas, sweet corn, French beans, and cauliflower.",
    longDesc: "A nutritious 5-way vegetable combination processed via premium IQF technology. Perfect for global distributors looking for versatile ready-to-cook vegetable mixes.",
    pkg: ["Vacuum Bags", "BOPP Export Packing"]
  },
  {
    id: 12,
    name: "Mix Veg 6-Way",
    cat: "frozen",
    catLabel: "Frozen Foods",
    image: "/mix-veg-6-way.png",
    bgColor: "#E8F5E9",
    moq: "500kg",
    grade: "Export Standard",
    desc: "Exquisite 6-ingredient blend including broccoli, carrots, peas, corn, beans, and peppers.",
    longDesc: "Our ultra-premium 6-way mix vegetable assortment designed for high-end retail and catering markets. Maintained under strict temperature controls to guarantee fresh taste and colors.",
    pkg: ["Vacuum Bags", "BOPP Export Packing"]
  },
  {
    id: 6,
    name: "Organic Spices Blend",
    cat: "spices",
    catLabel: "Organic Spices",
    image: "/spices.png",
    bgColor: "#FBE9E7",
    moq: "500kg",
    grade: "100% Pure Organic",
    desc: "Authentic, rich, and double PP packed Indian whole and grounded spices.",
    longDesc: "A wide variety of premium spices processed under strict hygienic conditions to preserve natural oils and aromatic qualities.",
    pkg: ["Double PP Bag", "Aseptic Barrier Pouches"]
  },
  {
    id: 7,
    name: "Onion Powder",
    cat: "dehydrated",
    catLabel: "Dehydrated Powders",
    image: "/onion-powder.png",
    bgColor: "#F5F5F5",
    moq: "500kg",
    grade: "Dehydrated Fine Mesh",
    desc: "Premium dehydrated white and red onion powder for global culinary uses.",
    longDesc: "Free-flowing moisture-controlled powder that carries full aromatic flavor of fresh Indian onions without any clumping.",
    pkg: ["Aluminium Foil Bags", "Drum Packing"]
  },
  {
    id: 8,
    name: "Garlic Powder",
    cat: "dehydrated",
    catLabel: "Dehydrated Powders",
    image: "/garlic-powder.png",
    bgColor: "#F5F5F5",
    moq: "500kg",
    grade: "Premium Food Grade",
    desc: "Strong aromatic dehydrated garlic powder, completely free from impurities.",
    longDesc: "Made from fresh cloves of garlic, dehydrated perfectly and pulverized into high-grade fine powder for food production.",
    pkg: ["Aluminium Foil Bags", "Fiber Drums"]
  },
  {
    id: 9,
    name: "Ginger Powder",
    cat: "dehydrated",
    catLabel: "Dehydrated Powders",
    image: "/ginger-powder.png",
    bgColor: "#FFF3E0",
    moq: "500kg",
    grade: "High Gingerol Grade",
    desc: "Sun-dried and finely ground ginger powder with premium pungency.",
    longDesc: "Derived from high-quality dried ginger (Sonth). Known for its strong medicinal properties and authentic sharp taste.",
    pkg: ["Multi-layer Paper Bags", "PP Bags"]
  },
  {
    id: 10,
    name: "Potato Powder",
    cat: "dehydrated",
    catLabel: "Dehydrated Powders",
    image: "/potato-powder.png",
    bgColor: "#F5F5F5",
    moq: "500kg",
    grade: "Fine Mesh Industrial",
    desc: "Dehydrated potato flakes powder perfect for snacks manufacturing.",
    longDesc: "Excellent binding agent with standard starch parameters, ideal for manufacturing snacks, soups, and ready-to-eat global products.",
    pkg: ["Bulk Kraft Paper Bags", "Poly Liners Bags"]
  }
];